module.exports = __webpack_public_path__ + "img/exercise_repeat_small.2963d132.svg";